export default "__VITE_ASSET__C7N23Hi$__"